import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logevent',
  templateUrl: './logevent.component.html',
  styleUrls: ['./logevent.component.css']
})
export class LogeventComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
